<template>
  <div>
    <v-dialog :value="value" persistent scrollable max-width="600">
      <v-card>
        <div class="text-xs-right">
          <v-btn fab small flat @click="$emit('input', false)">
            <v-icon>close</v-icon>
          </v-btn>
        </div>
        <div>
          <v-divider></v-divider>
          <v-layout>
            <template v-for="(sticker, index) in stickers">
              <v-flex
                :key="`list_sticker_${index}`"
                style="max-width: 50px; border-right: 1px solid #eee"
                :class="{ primary: currentPackage == index }"
                @click="currentPackage = index"
              >
                <div class="py-1 px-2">
                  <v-img
                    aspect-ratio="1"
                    :src="`/static/img/assets/stickers/${index}/${sticker[0]}.png`"
                  ></v-img>
                </div>
              </v-flex>
            </template>
          </v-layout>
          <v-divider></v-divider>
        </div>
        <v-card-text style="max-height: 600px">
          <v-layout wrap>
            <v-flex
              xs3
              sm2
              class="pa-1 sticker"
              v-for="(sticker, index) in stickers[currentPackage]"
              :key="`sticker_${index}`"
              style="cursor: pointer"
              @click="onClickSticker(currentPackage, sticker)"
            >
              <v-img
                aspect-ratio="1"
                :src="`/static/img/assets/stickers/${currentPackage}/${sticker}.png`"
                style=""
              ></v-img>
            </v-flex>
          </v-layout>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
export default {
  props: ['value'],
  data() {
    return {
      currentPackage: 11537,
      stickers: {
        11537: [
          52002734, 52002735, 52002736, 52002737, 52002738, 52002739, 52002740, 52002741, 52002742,
          52002743, 52002744, 52002745, 52002746, 52002747, 52002748, 52002749, 52002750, 52002751,
          52002752, 52002753, 52002754, 52002755, 52002756, 52002757, 52002758, 52002759, 52002760,
          52002761, 52002762, 52002763, 52002764, 52002765, 52002766, 52002767, 52002768, 52002769,
          52002770, 52002771, 52002772, 52002773
        ],
        11538: [
          51626497, 51626494, 51626495, 51626496, 51626498, 51626499, 51626500, 51626501, 51626502,
          51626503, 51626504, 51626505, 51626506, 51626507, 51626508, 51626509, 51626510, 51626511,
          51626512, 51626513, 51626514, 51626515, 51626516, 51626517, 51626518, 51626519, 51626520,
          51626521, 51626522, 51626523, 51626524, 51626525, 51626526, 51626527, 51626528, 51626529,
          51626530, 51626531, 51626532, 51626533
        ],
        11539: [
          52114113, 52114110, 52114111, 52114112, 52114114, 52114115, 52114116, 52114117, 52114118,
          52114119, 52114120, 52114121, 52114122, 52114123, 52114124, 52114125, 52114126, 52114127,
          52114128, 52114129, 52114130, 52114131, 52114132, 52114133, 52114134, 52114135, 52114136,
          52114137, 52114138, 52114139, 52114140, 52114141, 52114142, 52114143, 52114144, 52114145,
          52114146, 52114147, 52114148, 52114149
        ]
      }
    }
  },
  methods: {
    async onClickSticker(packageid, stickerid) {
      var result = await this.$swal.fire({
        title: `<img src="/static/img/assets/stickers/${packageid}/${stickerid}.png" style="max-height: 150px">`,
        text: this.$t('Do you want to send this sticker?'),
        showCancelButton: true,
        confirmButtonText: this.$t('Send'),
        cancelButtonText: this.$t('cancel'),
        reverseButtons: true
      })
      if (result.value) {
        this.$emit('sendSticker', {
          packageid: packageid,
          stickerid: stickerid
        })
        this.$emit('input', false)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.sticker {
  &:hover {
    transition: all ease 0.2s;
    transform: scale(1.1);
  }
}
</style>



// WEBPACK FOOTER //
// src/components/elements/StickerList.vue